import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { UseFormReturn } from "react-hook-form";

interface PoultryFieldsProps {
  form: UseFormReturn<{
    Age: string;
    Santé: string;
    Poids: string;
    Régime: string;
  }>;
}

export const PoultryFields = ({
  form,
}: PoultryFieldsProps) => {
  const { register, watch, setValue } = form;
  const health = watch("Santé");

  return (
    <>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="age">Âge</Label>
          <Input
            id="age"
            {...register("Age")}
            placeholder="Ex: 2 semaines"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="health">État de santé</Label>
          <Select 
            value={health} 
            onValueChange={(value) => setValue("Santé", value)}
          >
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="Bonne">Bonne</SelectItem>
              <SelectItem value="Moyenne">Moyenne</SelectItem>
              <SelectItem value="Mauvaise">Mauvaise</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="weight">Poids moyen</Label>
          <Input
            id="weight"
            {...register("Poids")}
            placeholder="Ex: 2.5 kg"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="diet">Régime alimentaire</Label>
          <Input
            id="diet"
            {...register("Régime")}
            placeholder="Ex: Aliment de croissance"
          />
        </div>
      </div>
    </>
  );
};